import React from "react";
import PageShell from "./_PageShell";

const BOOKS = [
  {
    t: "a³: Anchor, Awaken, Advance",
    s: "Reclaiming the Soul of the Muslim Educator.",
    status: "Featured Title",
    image:
      "https://customer-assets.emergentagent.com/job_hero-design-6/artifacts/pruzqzgh_a3-anchor-awaken-advance-cover.png",
  },
  {
    t: "The Way of the Murabbi",
    s: "A guide for the teacher of hearts.",
    status: "Available",
    image:
      "https://customer-assets.emergentagent.com/job_hero-design-6/artifacts/gf1huxcl_thewayofthemurabbicover.png",
  },
  {
    t: "Mind Elevations",
    s: "Essays on intellect, reflection, and the inner life.",
    status: "Available",
    image:
      "https://customer-assets.emergentagent.com/job_hero-design-6/artifacts/hsaq4ab7_mindelevationscover.png",
  },
  {
    t: "The Seashores of My Mind",
    s: "Reflections, observations, and quiet revelations.",
    status: "Available",
    image:
      "https://customer-assets.emergentagent.com/job_hero-design-6/artifacts/23y5gy80_seashoresofmymindcover.png",
  },
  {
    t: "Psalms of Gnosis",
    s: "A devotional companion for the seeker's heart.",
    status: "In Progress",
    image:
      "https://customer-assets.emergentagent.com/job_hero-design-6/artifacts/4zqpcwsy_man%20prayer%20psalm%20of%20gnosis.jpg",
  },
];

const Books = () => (
  <PageShell
    testId="books-page"
    eyebrow="05 — Books"
    title="Words that travel further than rooms."
    intro="Essays, frameworks and forthcoming books on the Murabbi method — practical scholarship for parents, teachers and leaders who want to raise a generation anchored in faith and awake to its calling."
  >
    <div className="grid sm:grid-cols-2 lg:grid-cols-5 gap-5">
      {BOOKS.map((b) => (
        <div
          key={b.t}
          className="group border border-white/10 bg-ink-soft/30 hover:border-azure/40 transition-colors duration-500"
        >
          <div className="relative aspect-[3/4] overflow-hidden bg-ink border-b border-white/10">
            <img
              src={b.image}
              alt={b.t}
              className="absolute inset-0 w-full h-full object-contain transition-transform duration-[1400ms] ease-out group-hover:scale-[1.03]"
            />
            {/* Inner azure frame */}
            <div className="absolute inset-3 border border-white/10 pointer-events-none" />
          </div>
          <div className="p-6">
            <div className="text-[10px] tracking-[0.32em] uppercase text-gold">
              {b.status}
            </div>
            <div className="font-serif text-white text-xl mt-3">{b.t}</div>
            <p className="text-white/60 mt-2 text-sm">{b.s}</p>
          </div>
        </div>
      ))}
    </div>
  </PageShell>
);

export default Books;
